var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "__trans-wrapper" },
    [
      _c(
        "confirm",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowTrans,
              expression: "isShowTrans"
            }
          ],
          staticClass: "trans-confirm",
          attrs: {
            showMask: true,
            title: _vm.$t("wallet.transfer"),
            btnUnuse: _vm.unTrans,
            closeIcon: true,
            close: _vm.closeTrans,
            singleBtn: true,
            leftBtnClick: _vm.validTrans,
            leftBtnTxt: _vm.$t("wallet.transfer")
          }
        },
        [
          _c("div", { staticClass: "__row" }, [
            _c("div", { staticClass: "__row_t" }, [
              _vm._v(_vm._s(_vm.$t("balance")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "__input_row __unuse_input __bold" }, [
              _c("img", {
                staticClass: "__icon",
                attrs: { src: _vm.token.icon || _vm.getIcon(_vm.token.tokenId) }
              }),
              _vm._v(
                " " + _vm._s(_vm.token.tokenSymbol) + "\n                "
              ),
              _c("span", { staticClass: "__right" }, [
                _vm._v(_vm._s(_vm.showAccBalance))
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "__row" },
            [
              _c("div", { staticClass: "__row_t" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("wallet.inAddress")) +
                    "\n                "
                ),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isValidAddress,
                        expression: "!isValidAddress"
                      }
                    ],
                    staticClass: "__err"
                  },
                  [_vm._v(_vm._s(_vm.$t("hint.addrFormat")))]
                )
              ]),
              _vm._v(" "),
              _c("vite-input", {
                attrs: {
                  valid: _vm.validAddr,
                  placeholder: _vm.$t("wallet.placeholder.addr")
                },
                model: {
                  value: _vm.inAddress,
                  callback: function($$v) {
                    _vm.inAddress = $$v
                  },
                  expression: "inAddress"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "__row" },
            [
              _c("div", { staticClass: "__row_t" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("wallet.sum")) +
                    "\n                "
                ),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.amountErr,
                        expression: "amountErr"
                      }
                    ],
                    staticClass: "__err"
                  },
                  [_vm._v(_vm._s(_vm.amountErr))]
                )
              ]),
              _vm._v(" "),
              _c("vite-input", {
                attrs: {
                  valid: _vm.testAmount,
                  type: "number",
                  placeholder: _vm.$t("wallet.placeholder.amount")
                },
                model: {
                  value: _vm.amount,
                  callback: function($$v) {
                    _vm.amount = $$v
                  },
                  expression: "amount"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "__row" },
            [
              _c("div", { staticClass: "__row_t" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("wallet.remarks")) +
                    "\n                "
                ),
                _c(
                  "span",
                  {
                    staticClass: "__row_hint",
                    class: { __err: _vm.messageErr }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t("wallet.remarksLong", { len: _vm.msgBalance })
                        ) +
                        "\n                "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("vite-input", {
                attrs: { placeholder: _vm.$t("wallet.placeholder.remarks") },
                model: {
                  value: _vm.message,
                  callback: function($$v) {
                    _vm.message = $$v
                  },
                  expression: "message"
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }